/**
 * Empty-state for the inbox. Friendly copy + a giant emoji glyph (no PNGs
 * to ship). The TMA spec explicitly calls for this so day-one users don't
 * stare at a blank screen.
 */
import { InboxIcon } from "./Icons";

export function InboxEmptyState(): JSX.Element {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
      <div className="rounded-full bg-tg-secondary-bg p-5 text-tg-hint">
        <InboxIcon size={32} />
      </div>
      <p className="font-medium text-tg-text">Your inbox is quiet</p>
      <p className="text-sm leading-relaxed text-tg-hint">
        Your wallet&rsquo;s on-chain messages will appear here.
        <br />
        Try sending yourself one to see how it works.
      </p>
    </div>
  );
}

export function ThreadEmptyState({ counterparty }: { counterparty: string }): JSX.Element {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 px-8 text-center">
      <p className="text-sm text-tg-hint">
        No messages with{" "}
        <span className="font-mono text-tg-text">{counterparty}</span> yet.
      </p>
      <p className="text-xs text-tg-hint">
        Send the first one below &mdash; the wallet will sign and broadcast a TON
        transfer with your comment attached.
      </p>
    </div>
  );
}
